import { render, staticRenderFns } from "./ScopesUpdateModal.vue?vue&type=template&id=31a41c3f&scoped=true"
import script from "./ScopesUpdateModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScopesUpdateModal.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ScopesUpdateModal.vue?vue&type=style&index=0&id=31a41c3f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a41c3f",
  null
  
)

export default component.exports